export default "__VITE_ASSET__C6Ju$KH6__"